<template>
  <link-handler :link="orderUrl" :external="!chargebeePlanId">
    <landing-page-order-card
      :background-image="backgroundImage"
      :test-id="testId"
    >
      <template #default>
        <strong
          class="flex h-full items-center justify-center text-center text-2xl uppercase"
        >
          {{ $t('landingpage/orderwidget/custom/title') }}
        </strong>
      </template>

      <template #button>
        <common-button
          v-if="chargebeePlanId"
          data-cy="custom-order-btn"
          :to="parsedOrderUrl"
          size="sm"
          data-track="landing-page-order-now"
          @click="onOrderClick"
        >
          {{
            preOrder ? $t('frontend/preorder-now') : $t('frontend/order-now')
          }}
        </common-button>
        <common-button
          v-else
          data-testid="custom-order-btn"
          :href="orderUrl"
          size="sm"
          data-track="landing-page-order-now"
        >
          {{
            preOrder ? $t('frontend/preorder-now') : $t('frontend/order-now')
          }}
        </common-button>
      </template>
    </landing-page-order-card>
  </link-handler>
</template>

<script setup lang="ts">
import type { StrapiImage } from '~/apollo/types/types';
import { parseRouteUrl } from '~/helpers/checkout';

const props = defineProps<{
  orderUrl?: string | null;
  chargebeePlanId?: string | null;
  preOrder?: boolean;
  backgroundImage: StrapiImage;
  testId?: string;
}>();

const checkoutStore = useCheckoutStore();

const parsedOrderUrl = computed(() => {
  if (!props.orderUrl) return props.orderUrl;
  return parseRouteUrl(props.orderUrl);
});

function onOrderClick() {
  checkoutStore.resetConfigSelections();
}
</script>
